var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuoteRight = function SvgQuoteRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M34 23c0 3.869-3.131 7-7 7h-2a1 1 0 1 1 0-2h2c2.762 0 5-2.238 5-5a1 1 0 0 0-1-1h-7a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v11m-16-7v7c0 3.869-3.131 7-7 7H9a1 1 0 1 1 0-2h2c2.762 0 5-2.238 5-5a1 1 0 0 0-1-1H8a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2z"
  })));
};
export default SvgQuoteRight;